// extracted by mini-css-extract-plugin
export default {"loading":"location-status-header_loading__yxk84","l":"location-status-header_l__sh+cb"};